<template>
    <div class="confirmation-order">
        <b-container>
            <b-row>
                <b-col cols="12" class="mb-5">
                    <h3 class="mb-4"><img class="icon" src="../../assets/imgs/icn_confirmation.svg" alt=""> Confirmación de orden</h3>   
                    <p>Se ha enviado la información de tu orden. Espera un correo de confirmación en <span><strong>{{data.mail}}</strong></span>. Aquí puedes ver los detalles de tu orden.</p>
                </b-col>
                <b-col cols="12" class="mb-3">
                    <h3><img class="icon" src="../../assets/imgs/icn_orderdetails.svg" alt=""> Detalles de tu orden</h3>   
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Hombre / Mujer</span>
                    <p>{{data.gender}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Nombre y Apellidos</span>
                    <p>{{data.name}} {{data.first_lastname}} {{data.second_lastname}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Especialidad</span>
                    <p>{{data.specialty}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Nombre de la Empresa o Institución</span>
                    <p>{{data.hospital}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Correo Electrónico</span>
                    <p>{{data.mail}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Teléfono de Contacto</span>
                    <p>{{data.phone}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Teléfono de consultorio</span>
                    <p>{{data.phone_office}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span># de extensión</span>
                    <p>{{data.phone_office_ext}}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <table class="table b-table">
                        <thead role="rowgroup">
                            <tr>
                                <th>
                                    Producto
                                </th>
                                <th>
                                    Modelo
                                </th>
                                <th>
                                    Color
                                </th>
                                <th>
                                    Talla
                                </th>
                                <th>
                                    Cantidad
                                </th>
                                <!-- <th>
                                    Bordado
                                </th>
                                <th>
                                    Logotipo
                                </th> -->
                            </tr>
                        </thead>
                        <tbody role="rowgroup">
                            <tr role="row" v-for="(element) in data.ownItem" :key="element">
                                <td>
                                    {{ element.type }}
                                </td>
                                <td>{{ element.model}}</td>
                                <td class="">{{element.color}}</td>
                                <td class="">{{element.size}}</td>
                                <td class="">{{element.qty}}</td>
                                <!-- <td class="">
                                    <div v-if="element.embroid_font_color" style="display: flex;">Color: {{element.embroid_font_color}}</div>
                                    <p v-if="element.embroid_position" class="mb-0">Posición: {{element.embroid_position}}</p>
                                    <p v-if="element.embroid_font" class="mb-0">Letra: {{element.embroid_font}}</p>
                                </td>
                                <td>
                                    <p v-show="element.logo" class="mb-0">Logotipo: {{ element.logo }}</p>
                                    <img :src="element.logo_image" style="width: 100%" alt="">
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                    <table>
                        <tr><td style="padding-top: 5px !important;padding-bottom: 5px !important;">Modelos:</td><td style="padding-top: 5px !important;padding-bottom: 5px !important;">$ {{Number(data.total_price).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td></tr>
                        <tr v-if="data.total_logo>0"><td style="padding-top: 5px !important;padding-bottom: 5px !important;">Logo:</td><td style="padding-top: 5px !important;padding-bottom: 5px !important;">$ {{Number(data.total_logo).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td></tr>
                        <tr v-if="data.total_embroid>0"><td style="padding-top: 5px !important;padding-bottom: 5px !important;">Personalizado:</td><td style="padding-top: 5px !important;padding-bottom: 5px !important;">$ {{Number(data.total_embroid).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td></tr>
                        <tr><td style="padding-top: 5px !important;padding-bottom: 5px !important;">Subtotal:</td><td style="padding-top: 5px !important;padding-bottom: 5px !important;">$ {{Number(data.total_subtotal).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td></tr>
                        <tr v-if="data.total_discount>0"><td style="padding-top: 5px !important;padding-bottom: 5px !important;">Descuento:</td><td style="padding-top: 5px !important;padding-bottom: 5px !important;"> - $ {{Number(data.total_discount).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td></tr>
                        <tr><td style="padding-top: 5px !important;padding-bottom: 5px !important;"><b>Costo total:</b> <td style="padding-top: 5px !important;padding-bottom: 5px !important;">$ {{Number(data.total_costo).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td></tr>
                    </table>
                </b-col>
                <b-col cols="4">
                    <b-button v-on:click="logOut" class="btn">Cerrar sesión</b-button>
                </b-col>
                <b-col cols="4">
                    <router-link :to="{ name: 'FormPage'}" class="btn">Nuevo registro</router-link>
                </b-col>

            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: Array,
                required: true
            },
        },
        methods: {
            logOut(){
                sessionStorage.removeItem('dataOrder')
                this.$router.push({ name: 'login'})
            }
        },
        created() {
            var datalist = sessionStorage.getItem('dataOrder');
            if (!this.data) {
                this.data = JSON.parse(datalist)
            }
            if (!this.data){
                this.$router.push('/orden')
            }
        },
        destroyed() {
            sessionStorage.removeItem('dataOrder')
        },
        data() {
            return {
            }
        }
    }
</script>

<style scoped>
.confirmation-order{
    padding: 70px 15%;
}

h3{
    font-weight: bold;
    font-size: 25px;
}
span{
    font-size: 16px;
    color: #5965B1;
}
p,
p > span{
   font-size: 20px; 
}

.btn,
.btn:focus,
.btn:hover{
    background: #F15E1A !important;
    border: none;
    color: #fff !important;
    width: 100%;
}
.icon{
    margin-top: -5px;
    margin-right: 10px;
}
@media (max-width: 1600px) {
    .confirmation-order{
        padding: 50px 15%;
    }
    .confirmation-order .container{
        padding: 0 11%;
    }
    h3{
        font-size: 18px;
    }
    span{
        font-size: 12px;
    }
    p,
    p > span{
        font-size: 15px; 
    }
    .note{
        font-size: 11px;
    }
    .icon{
        width: 20px;
        margin-right: 5px;
    }
}
@media (max-width: 768px) {
    .confirmation-order .container{
        padding: 0;
    }
}
</style>